import InvestmentService from "../service";
import { router } from "@/router";

export const actions = {
  listInvestments: ({ commit, dispatch }, quiet) => {
    if (!quiet) {
      dispatch("enableLoading");
    }

    InvestmentService.list()
      .then(res => {
        dispatch("disableLoading");
        commit("setInvestments", res.data);
      })
      .catch(e => {
        dispatch("disableLoading");
        dispatch("createGlobalMessage", {
          type: "error",
          message: e.response.data.message,
          timeout: 6000
        });
      });
  }
};

export default {};
